import { ChangeDetectionStrategy, Component, input } from "@angular/core";

/**
 * Vega's avatar: the chat panel's tab and header, and the speaker row on
 * Vega's replies. Decorative — the visible "Vega" beside it (or the
 * control's aria-label) names it. The art is a full-bleed square (a green
 * hood on a warm cream background) rounded here; the cream edge stands out
 * on both themes, so it needs no ring. 32/64/128 px sources (src/assets/img/vega/) keep it crisp
 * at 1x/2x/4x for any display size up to 32px.
 */
@Component({
  selector: "tp-vega-avatar",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "aria-hidden": "true" },
  template: `<img
    src="assets/img/vega/vega-avatar-32.png"
    srcset="assets/img/vega/vega-avatar-32.webp 1x, assets/img/vega/vega-avatar-64.webp 2x, assets/img/vega/vega-avatar-128.webp 4x"
    [width]="size()"
    [height]="size()"
    [style.width.px]="size()"
    [style.height.px]="size()"
    alt=""
    draggable="false"
  />`,
  styles: `
    :host {
      display: inline-flex;
      flex: none;
    }
    img {
      display: block;
      border-radius: 22%;
    }
  `,
})
export class VegaAvatarComponent {
  /** Display size in CSS px. */
  readonly size = input(22);
}
